import React from "react";

interface IconProps {
  className?: string;
  active?: boolean;
  style?: React.CSSProperties;
}

export const DashboardIcon: React.FC<IconProps> = ({ className = "w-5 h-5", active = false, style }) => (
  <svg className={className} width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
    <path
      d='M5 1H1.66667C1.29848 1 1 1.29848 1 1.66667V6.33333C1 6.70152 1.29848 7 1.66667 7H5C5.36819 7 5.66667 6.70152 5.66667 6.33333V1.66667C5.66667 1.29848 5.36819 1 5 1Z'
      stroke={active ? "#3B82F6" : "#444444"}
      strokeWidth='1.33'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.3333 1H9C8.63181 1 8.33333 1.29848 8.33333 1.66667V3.66667C8.33333 4.03486 8.63181 4.33333 9 4.33333H12.3333C12.7015 4.33333 13 4.03486 13 3.66667V1.66667C13 1.29848 12.7015 1 12.3333 1Z'
      stroke={active ? "#3B82F6" : "#444444"}
      strokeWidth='1.33'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.3333 7H9C8.63181 7 8.33333 7.29848 8.33333 7.66667V12.3333C8.33333 12.7015 8.63181 13 9 13H12.3333C12.7015 13 13 12.7015 13 12.3333V7.66667C13 7.29848 12.7015 7 12.3333 7Z'
      stroke={active ? "#3B82F6" : "#444444"}
      strokeWidth='1.33'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5 9.66667H1.66667C1.29848 9.66667 1 9.96514 1 10.3333V12.3333C1 12.7015 1.29848 13 1.66667 13H5C5.36819 13 5.66667 12.7015 5.66667 12.3333V10.3333C5.66667 9.96514 5.36819 9.66667 5 9.66667Z'
      stroke={active ? "#3B82F6" : "#444444"}
      strokeWidth='1.33'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const BrickIcon: React.FC<IconProps> = ({ className = "w-5 h-5", active = false, style }) => (
  <svg className={className} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
    <g>
      <path
        d='M6.66671 14.6001V9.3334M6.66671 9.3334L1.40004 6.06674M6.66671 9.3334L14.6 4.7334M9.33331 13.2V7.79997M12 11.6666V6.26661M14.6666 5.13327C14.6666 4.73327 14.4 4.33327 14.1333 4.13327L9.93331 1.53327C9.76059 1.43509 9.56532 1.38347 9.36665 1.38347C9.16797 1.38347 8.9727 1.43509 8.79998 1.53327L1.93331 5.53327C1.59998 5.66661 1.33331 6.06661 1.33331 6.46661V10.8666C1.33331 11.1999 1.59998 11.6666 1.86665 11.8666L6.06665 14.4666C6.23937 14.5648 6.43464 14.6164 6.63331 14.6164C6.83199 14.6164 7.02726 14.5648 7.19998 14.4666L14.0666 10.4666C14.4 10.2666 14.6666 9.79994 14.6666 9.46661V5.13327Z'
        stroke={active ? "#3B82F6" : "#444444"}
        strokeWidth='1.33'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_123_143'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const EarnIcon: React.FC<IconProps> = ({ className = "w-5 h-5", active = false, style }) => (
  <svg className={className} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
    <g clipPath='url(#clipEarn)'>
      <path
        d='M7.33331 10H8.66665C9.02027 10 9.35941 9.85952 9.60946 9.60947C9.8595 9.35942 9.99998 9.02028 9.99998 8.66666C9.99998 8.31304 9.8595 7.9739 9.60946 7.72385C9.35941 7.4738 9.02027 7.33333 8.66665 7.33333H6.66665C6.26665 7.33333 5.93331 7.46666 5.73331 7.73333L1.99998 11.3333M4.66665 14L5.73331 13.0667C5.93331 12.8 6.26665 12.6667 6.66665 12.6667H9.33331C10.0666 12.6667 10.7333 12.4 11.2 11.8667L14.2666 8.93335C14.5239 8.69023 14.6741 8.35488 14.6841 8.00106C14.6941 7.64724 14.5631 7.30394 14.32 7.04668C14.0769 6.78942 13.7415 6.63927 13.3877 6.62927C13.0339 6.61927 12.6906 6.75023 12.4333 6.99335L9.63331 9.59335M1.33331 10.6667L5.33331 14.6667M12.6 6.00006C12.6 7.06781 11.7345 7.93339 10.6667 7.93339C9.59896 7.93339 8.73338 7.06781 8.73338 6.00006C8.73338 4.93231 9.59896 4.06673 10.6667 4.06673C11.7345 4.06673 12.6 4.93231 12.6 6.00006ZM5.99998 3.33333C5.99998 4.4379 5.10455 5.33333 3.99998 5.33333C2.89541 5.33333 1.99998 4.4379 1.99998 3.33333C1.99998 2.22876 2.89541 1.33333 3.99998 1.33333C5.10455 1.33333 5.99998 2.22876 5.99998 3.33333Z'
        stroke={active ? "#3B82F6" : "#444444"}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clipEarn'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export const SwapIcon: React.FC<IconProps> = ({ className = "w-5 h-5", active = false, style }) => (
  <svg className={className} width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg' style={style}>
    <path
      d='M3.83301 6C4.93758 6 5.83301 5.10457 5.83301 4C5.83301 2.89543 4.93758 2 3.83301 2C2.72844 2 1.83301 2.89543 1.83301 4C1.83301 5.10457 2.72844 6 3.83301 6ZM3.83301 6V10.6667C3.83301 11.0203 3.97348 11.3594 4.22353 11.6095C4.47358 11.8595 4.81272 12 5.16634 12H8.49967M8.49967 4H11.833C12.1866 4 12.5258 4.14048 12.7758 4.39052C13.0259 4.64057 13.1663 4.97971 13.1663 5.33333V10M8.49967 4L10.4997 6M8.49967 4L10.4997 2M13.1663 10C12.0618 10 11.1663 10.8954 11.1663 12C11.1663 13.1046 12.0618 14 13.1663 14C14.2709 14 15.1663 13.1046 15.1663 12C15.1663 10.8954 14.2709 10 13.1663 10ZM8.49967 12L6.49967 10M8.49967 12L6.49967 14'
      stroke={active ? "#3B82F6" : "#444444"}
      strokeWidth='1.33'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
